import { useEffect } from "react";
import "./Ads.css";

export default function HorizontalAds() {
  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.log("AdSense Error:", err);
    }
  }, []);

  return (
    <div className="horizontal-ad-wrapper">
      <div className="ad-label" style={{fontSize:"12px"}}>Sponsored</div>

      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-5162535306990850"
        data-ad-slot="1839208150"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}